import request from '../../request';
import { surveyTemplateServiceAPI } from './insightsUrls';

export class surveyTemplateService {
  static addUpdate(id, n, audience, tags, ischeckIn, user) {
    return request({
      url: surveyTemplateServiceAPI.addUpdate(id, n, audience, tags, ischeckIn),
      method: 'POST',
      data: user,
    })
      .then((response) => response)
      .catch((response) => response);
  }
  static getAllTemplatesForAdmin() {
    return request({
      url: surveyTemplateServiceAPI.getAllTemplatesForAdmin(),
      method: 'GET',
    })
      .then((response) => response)
      .catch((response) => response);
  }

  static deleteTemplate(id) {
    return request({
      url: surveyTemplateServiceAPI.delete(id),
      method: 'DELETE',
    })
      .then((response) => response)
      .catch((response) => response);
  }
  // static putTag(tag) {
  //   return request({
  //     url: surveyTemplateServiceAPI.put,
  //     method: 'PUT',
  //     data: tag,
  //   })
  //     .then((response) => response)
  //     .catch((response) => response);
  // }
  // static postTag(tag) {
  //   return request({
  //     url: surveyTemplateServiceAPI.post,
  //     method: 'POST',
  //     data: tag,
  //   })
  //     .then((response) => response)
  //     .catch((response) => response);
  // }
  // // static mergeTag(data) {
  // //   return request({
  // //     url: tagServiceAPI.mergeTag,
  // //     method: 'POST',
  // //     data,
  // //   })
  // //     .then((response) => response)
  // //     .catch((response) => response);
  // // }
}

export default surveyTemplateService;
